import { selectBasketRentingSummary, selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import Schedule from 'containers/OrderDetails/Summary/Schedule'
import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { displayPrice } from 'utils/string'
import { useSelector } from 'react-redux'
import { Fragment } from 'react'

const SummarySection = ({ list }) => {
  const rentingSummary = useSelector(selectBasketRentingSummary)
  const toPay = useSelector(selectBasketToPay)
  const { t } = useTranslation('basket')

  return (
    <>
      <div>
        <div className='list__header element__title'>{t('summary')}</div>
        <div className='list__element --big'>
          <div className='element__title'>{t('feesNow')}</div>
          <div className='element__desc'>
            {list.map((item) => toPay?.[item.identifier]?.to_pay
              ? <Fragment key={item.identifier}>
                {toPay[item.identifier].to_pay.list?.map((toPayItem, idx) => <div
                  key={idx}
                  className={`group --${toPayItem.type}`}>
                  <span>{toPayItem.text}:</span>
                  <span className='--marked'>{displayPrice(toPayItem.price)}</span>
                </div>)}
                {item?.deliveries?.map((deliveryItem, idx) => <div
                  key={idx}
                  className='group'>
                  <span>{t('delivery')}{deliveryItem.deliveryType ? ` (${t(deliveryItem.deliveryType)})` : ''}:</span>
                  <span className='--marked'>{displayPrice(rentingSummary?.deliveryPrice?.deliveries?.[deliveryItem.externalDeliveryId]?.grossPrice || 0)}</span>
                </div>)}
              </Fragment>
              : <Skeleton key={item.identifier} />)}
          </div>
          <div className='orderInfo__summary__sum'>
            <span>{t('total')}:</span>
            <span>{displayPrice(rentingSummary?.to_pay?.now?.grossPrice || 0)}</span>
          </div>
        </div>
      </div>

      {rentingSummary?.to_pay?.monthly && rentingSummary?.to_pay?.monthly.length > 0 && <div>
        <div className='list__element --big'>
          <div className='element__title'>{t('schedule')}</div>
          <Schedule schedule={rentingSummary.to_pay.monthly} />
        </div>
      </div>}
    </>
  )
}

export default SummarySection